import { render, staticRenderFns } from "./Milestone.vue?vue&type=template&id=61f0112e&scoped=true&"
import script from "./Milestone.vue?vue&type=script&lang=js&"
export * from "./Milestone.vue?vue&type=script&lang=js&"
import style0 from "./Milestone.vue?vue&type=style&index=0&id=61f0112e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f0112e",
  null
  
)

export default component.exports